var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardreturnonassets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 36,
    viewBox: "0 0 26 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9296 0H0V36H25.9296V0Z",
    fill: "#00A7A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9651 0H0V36H12.9651V0Z",
    fill: "#26D9DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7439 3.60657H3.18634V10.4466H22.7439V3.60657Z",
    fill: "#008E8E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67616 12.8358H3.18634V16.3256H6.67616V12.8358Z",
    fill: "#FFF1D8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0321 12.8358H8.5423V16.3256H12.0321V12.8358Z",
    fill: "#FFF1D8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.388 12.8358H13.8982V16.3256H17.388V12.8358Z",
    fill: "#FFF1D8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.744 12.8358H19.2542V16.3256H22.744V12.8358Z",
    fill: "#FFF1D8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67616 18.1918H3.18634V21.6816H6.67616V18.1918Z",
    fill: "#FFF1D8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0321 18.1918H8.5423V21.6816H12.0321V18.1918Z",
    fill: "#FFF1D8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M17.388 18.1918H13.8982V21.6816H17.388V18.1918Z",
    fill: "#FFF1D8"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M22.744 18.1918H19.2542V21.6816H22.744V18.1918Z",
    fill: "#FFF1D8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67616 23.5476H3.18634V27.0374H6.67616V23.5476Z",
    fill: "#FFF1D8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0321 23.5476H8.5423V27.0374H12.0321V23.5476Z",
    fill: "#FFF1D8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.388 23.5476H13.8982V27.0374H17.388V23.5476Z",
    fill: "#FFF1D8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.744 23.5476H19.2542V27.0374H22.744V23.5476Z",
    fill: "#FFF1D8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67616 28.9044H3.18634V32.3942H6.67616V28.9044Z",
    fill: "#FFF1D8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0321 28.9044H8.5423V32.3942H12.0321V28.9044Z",
    fill: "#FFF1D8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.388 28.9044H13.8982V32.3942H17.388V28.9044Z",
    fill: "#FFF1D8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.744 28.9044H19.2542V32.3942H22.744V28.9044Z",
    fill: "#FFF1D8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9651 3.60657H3.18634V10.4466H12.9651V3.60657Z",
    fill: "#0CA7A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardreturnonassets);
export default __webpack_public_path__ + "static/media/dashboardreturnonassets.682d8db2ea7c88a1348037261bab3b60.svg";
export { ForwardRef as ReactComponent };